import styled from 'styled-components';

export const SearchWidgetWrap = styled.section`
  width: 50%;
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.13) 0px 0.2rem 1.2rem 0px;
  position: relative;
  z-index: 6;
  border-radius: 1.2rem;
  padding: 2.5rem;
  margin-right: 2rem;
  height: ${props => props.height};
`;

export const OptionWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 1rem;
`

export const CustomRadioWrap = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 33%;
  cursor: pointer;
`

export const labelTxt = styled.span(
  props =>`
    font-size: 1.8rem;
    font-family: ${props.theme.font.fontFamily};
    padding-left: 1rem;
    font-weight: 600;
    color: #4f525a;
`)
  
export const InputText = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    padding: 1rem 0;
    position: relative;
    border-bottom: 1px solid #eff3f8;
    &.active {
      border-bottom: 2px solid #2276e3;
    }
    label {
      font-size: 1.6rem;
      color: #898b91;
    }
    cursor: pointer;
    input[type=text] {
      border: 0;
      outline: 0;
      padding: 1rem 0 0;
      font-size: 1.8rem;
      font-weight: 600;
      font-family: ${props.theme.font.fontFamily};
      &::placeholder { 
        overflow: visible; 
        font-weight: 600;
        color: #898b91;
      }
    }
`);

export const CalendarBlock = styled.div`
  padding: 1rem 0;
  border-bottom: 1px solid #eff3f8;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  label {
    font-size: 1.6rem;
    color: #898b91;
  }
  cursor: pointer;
`;

export const PickupDate = styled.div`
  width: 50%;
  border-right: 1px solid #eff3f8;
  flex-direction: column;
  display: flex;
  cursor: pointer;
`

export const DateTxt = styled.span(
props =>`
  color: black;
  font-family: ${props.theme.font.fontFamily};
  font-size: 1.8rem;
  font-weight: 600;
  padding-top: 1rem
`)

export const PickupTime = styled.div`
  width: 50%;
  align-items: flex-end;
  flex-direction: column;
  display: flex;
`

export const DateWrapper = styled.div(
  props => `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    input {
      border: 0;
      outline: 0;
      padding: 1rem 0;
      font-size: 1.8rem;
      font-weight: 600;
      font-family: ${props.theme.font.fontFamily};
      &::placeholder { 
        overflow: visible; 
        font-weight: 600;
        color: #898b91;
      } 
    }
  `
);

export const DateTabs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    border-radius: 8px;
    background-color: rgba(34, 118, 227, 0.1);
    padding: 1rem 1.5rem;
    font-size: 1.4rem;
    color: #2276e3;
    margin-left: 1rem;
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2rem 0 1rem;
  font-size: 1.4rem;
`;

export const goSafeTag = styled.p`
  background: #e9f6ea;
  border-radius: 0.4rem;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: row;
  margin-right: 0.5rem;
  span {
    font-weight: 600;
    color: black;
  }
`;

export const HrPackageWrapper = styled.div`
  margin: 3rem 0;
`

export const ButtonWrap = styled.div`
  display: flex;
  position: absolute;
  bottom: -3rem;
  left: 50%;
  transform: translateX(-50%);
  button {
    border: 0;
    outline: 0;
    background-color: rgb(255, 109, 56);
    height: 6rem;
    width: 27rem;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 3rem;
    color: white;
    font-size: 2.2rem;
    font-family: 'Rubik';
    font-weight: 600;
    box-shadow: rgba(0, 0, 0, 0.13) 0px 0.2rem 1.2rem 0px;
  }
`

export const SwapIconWrap = styled.span(
  props => `
  position: absolute;
  right: 0;
  transform: rotate(-90deg);
  top: ${props?.error ? "15rem" : "13.6rem"};
  right: 1.5rem;
`);

export const MulticityStopsText = styled.div`
  padding: 1rem 0 0;
  font-size: 1.6rem;
  color: #4a4a4a;

  & .darkTxt {
    color: #000;
  }
`

export const StopoversTextCont = styled.div`
	font-family: 'Rubik';
	font-size: 1.6rem;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.38;
	letter-spacing: normal;
	color: #2276e3;
  padding: 1rem 0 0;
  cursor: pointer;

  span {
    font-family: 'Rubik';
    display: inline-flex;
    background-image: linear-gradient(100deg, #976fc3 0%, #e35471 100%);
    justify-content: center;
    padding: 2px 7px 3px;
    margin-left: 10px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
  }
`;

export const StopOversCont = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
`

export const CloseCont = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #4a4a4a;
  opacity: 0.6;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  & .close{
    width: 10px;
    height: 10px;
    margin-top: 8px;
    display: flex;
    cursor: pointer;
  }

  & .close:before{
    content: "";
    background: #fff;
    position: absolute;
    width: 10px;
    border: 1px solid #fff;
    transform: rotate(-45deg);
  }

  & .close:after{
    content: "";
    background: #fff;
    position: absolute;
    width: 10px;
    border: 1px solid #fff;
    transform: rotate(45deg);
  }
`

export const ErrorContainer = styled.div`
  font-size: 12px;
  color: #ff3a5c;
  font-weight: 600;
  margin-top: 0.3rem;
`
